import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    marginTop: '2rem !important',
  },
  button: {
    backgroundColor: `${theme.btnGray} !important`,
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.875rem',
    margin: '.25rem 0 !important',
    opacity: 1,
    padding: '.6625rem 1.5em .6625rem !important',
    whiteSpace: 'nowrap !important',
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  buttonContainer: {
    display: 'flex',
    alginItems: 'center',
    marginTop: '1.25rem',
    width: '100%',
  },
  selectAllHeader: {},
});

export default styles;
